const TRUST_LABELS = [
  { label: "Claimed venue", matches: (trust, listing) => trust.claimedVenue || listing.isClaimed },
  { label: "Owner-confirmed details", matches: (trust) => trust.ownerConfirmed },
  { label: "Community-rated", matches: (trust, listing) => trust.communityRated || (listing.communityReviewCount || 0) >= 3 },
  { label: "OSM-sourced details", matches: (trust) => trust.osmSourced },
  { label: "Third-party venue data", matches: (trust, listing) => !trust.osmSourced && trust.thirdPartySourced && !listing.isClaimed },
  { label: "Demo sample", matches: (trust, listing) => trust.demoSample || listing.isDemo },
];

function getTrustLabels(listing, trust) {
  return TRUST_LABELS.filter((item) => item.matches(trust, listing)).map((item) => item.label);
}

export function TrustSourceLine({ listing, compact = false }) {
  const trust = listing.trustSources || {};
  const labels = getTrustLabels(listing, trust);
  if (!labels.length && listing.lastVerified) labels.push("Information checked");
  if (!labels.length) return null;
  return (
    <div className={`flex flex-wrap items-center ${compact ? "gap-1.5" : "gap-2"}`} data-testid={`trust-sources-${listing.id}`}>
      {labels.map((label) => <span key={label} className={`font-body border border-slate-200 bg-white text-gray-600 rounded ${compact ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2.5 py-1"}`} data-testid={`trust-source-${listing.id}-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{label}</span>)}
      {listing.lastVerified && !compact && <span className="font-body text-xs text-gray-500" data-testid={`trust-verified-date-${listing.id}`}>Checked {new Date(listing.lastVerified).toLocaleDateString("en-US", { month: "short", year: "numeric" })}</span>}
      {trust.osmSourced && !compact && <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer" className="font-body text-xs text-navy underline underline-offset-4" data-testid={`osm-attribution-${listing.id}`}>© OpenStreetMap contributors</a>}
    </div>
  );
}